import React, { useState, useEffect } from 'react';
import {
    getAuditionScreeningQuestionResults, getEmployerGradeQuestion, getAuditionQuestionResults
} from 'requests/JobOpportunityRequests';
import { AUTOGRADED_ANSWER_TYPES } from 'helper/constants';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import ReadOnlyVersion from './readOnly';
import EditableVersion from './editable';

const GradeBlock = ({ readOnly, ...props }) => {
    const [questionNumber, setQuestionNumber] = useState(0);
    const [screenQuestionResults, setScreenQuestionResults] = useState([]);
    const [currentGrade, setCurrentGrade] = useState(null);
    const [screenSelected, setScreenSelected] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [taskNumber, setTaskNumber] = useState(0);
    const [questionResultIndex, setQuestionResultIndex] = useState(0);
    const [questionResults, setQuestionResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const { getAuditionScreeningResults = getAuditionScreeningQuestionResults,
        loadGradeQuestion = getEmployerGradeQuestion,
        getAuditionResults = getAuditionQuestionResults, candidate, gradeableCard = false, propPublic, hideCandidateDetails, userAudition } = props;
    const { userAuditionId, completed = true } = candidate;

    const returnCurrentTask = question => (question.candidateTasks?.length ? question?.candidateTasks[taskNumber] : null);

    useEffect(() => {
        setQuestionNumber(0);
        setTaskNumber(0);
        getScreeningResults();
        getResults();
    }, [userAuditionId]);

    useEffect(() => {
        if (!currentQuestion) return;
        setGradeQuestion(currentQuestion);
        setQuestionResultIndex(0);
    }, [taskNumber, currentQuestion]);

    const getScreeningResults = () => {
        getAuditionScreeningResults(userAuditionId)
            .then(({ success, data }) => {
                if (success) {
                    setScreenQuestionResults(data);
                }
            });
    };

    const getQuestion = (id) => {
        loadGradeQuestion(id)
            .then(({ data, success }) => {
                if (success) {
                    setGradeQuestion(data);
                }
            });
    };

    const gotoQuestion = (key) => {
        setScreenSelected(false);
        setQuestionNumber(parseInt(key, 10));
        setCurrentQuestion(null);
        setTaskNumber(0);
        getQuestion(questionResults[key].id);
    };


    const setGradeQuestion = (question = currentQuestion) => {
        let newQuestion = question;
        const currentTask = returnCurrentTask(question);
        if (currentTask) {
            // eslint-disable-next-line prefer-destructuring
            newQuestion = currentTask.questionResults[questionResultIndex];
        }
        const { question: { willBeGraded, answerType } } = newQuestion;
        const isAutograded = AUTOGRADED_ANSWER_TYPES.some(el => el === answerType) && willBeGraded;
        setCurrentQuestion(question);
        if (isAutograded) {
            setCurrentGrade(newQuestion.grade);
        } else if (!willBeGraded) {
            setCurrentGrade(null);
        } else {
            setCurrentGrade((gradeableCard || !propPublic) ? newQuestion.userGrade : newQuestion.grade);
        }
    };

    const getResults = () => {
        if (!completed) {
            setScreenSelected(true);
            return;
        }

        setIsLoading(true);
        getAuditionResults(userAuditionId)
            .then(({ success, data }) => {
                if (success) {
                    setQuestionResults(data);
                    if (!data.length) {
                        setScreenSelected(true);
                    } else {
                        getQuestion(data[0].id);
                    }
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    if (isLoading) {
        return (
            <Typography className="u-mrg--bx2" variant="h5">
                <span>Candidate Answers</span>
                <CircularProgress color="primary" className="u-mrg--lx2" size={20} />
            </Typography>
        );
    }

    const gradeProps = {
        screenQuestionResults,
        currentQuestion,
        isLoading,
        questionResults,
        gotoQuestion,
        currentGrade,
        questionNumber,
        setGradeQuestion,
        screenSelected,
        setScreenSelected,
        taskNumber,
        setTaskNumber,
        setQuestionResultIndex,
        returnCurrentTask,
        setCurrentQuestion,
        setQuestionResults,
        hideCandidateDetails
    };

    if (readOnly) {
        return <ReadOnlyVersion {...props} gradeProps={gradeProps} />;
    }
    return <EditableVersion {...props} gradeProps={gradeProps} />;
};

export default GradeBlock;
